import React, { useState, useRef } from 'react';
import html2canvas from 'html2canvas';

/* =====================================================================
   VALIDASI GAME — GAMES PANEL
   Menu utama: Validator Struk · Checker ID · Table Price
   ===================================================================== */

// ---------- IKON (SVG inline, tanpa dependensi tambahan) ----------
const Icon = ({ name, size = 16, className = "" }) => {
    const paths = {
        receipt: "M9 14l6-6M9.5 8.5h.01M14.5 13.5h.01M5 21V5a2 2 0 012-2h10a2 2 0 012 2v16l-3-2-2 2-2-2-2 2-2-2-3 2z",
        search: "M21 21l-4.35-4.35M11 19a8 8 0 100-16 8 8 0 000 16z",
        table: "M3 10h18M3 14h18M10 3v18M5 3h14a2 2 0 012 2v14a2 2 0 01-2 2H5a2 2 0 01-2-2V5a2 2 0 012-2z",
        settings: "M12 15a3 3 0 100-6 3 3 0 000 6zM19.4 15a1.7 1.7 0 00.3 1.8l.1.1a2 2 0 11-2.8 2.8l-.1-.1a1.7 1.7 0 00-1.8-.3 1.7 1.7 0 00-1 1.5V21a2 2 0 01-4 0v-.1a1.7 1.7 0 00-1.1-1.5 1.7 1.7 0 00-1.8.3l-.1.1a2 2 0 11-2.8-2.8l.1-.1a1.7 1.7 0 00.3-1.8 1.7 1.7 0 00-1.5-1H3a2 2 0 010-4h.1a1.7 1.7 0 001.5-1.1 1.7 1.7 0 00-.3-1.8l-.1-.1a2 2 0 112.8-2.8l.1.1a1.7 1.7 0 001.8.3H9a1.7 1.7 0 001-1.5V3a2 2 0 014 0v.1a1.7 1.7 0 001 1.5 1.7 1.7 0 001.8-.3l.1-.1a2 2 0 112.8 2.8l-.1.1a1.7 1.7 0 00-.3 1.8V9a1.7 1.7 0 001.5 1H21a2 2 0 010 4h-.1a1.7 1.7 0 00-1.5 1z",
        copy: "M8 16H6a2 2 0 01-2-2V6a2 2 0 012-2h8a2 2 0 012 2v2m-6 12h8a2 2 0 002-2v-8a2 2 0 00-2-2h-8a2 2 0 00-2 2v8a2 2 0 002 2z",
        check: "M5 13l4 4L19 7",
        image: "M4 16l4.6-4.6a2 2 0 012.8 0L16 16m-2-2l1.6-1.6a2 2 0 012.8 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z",
        box: "M20 7l-8-4-8 4m16 0l-8 4m8-4v10l-8 4m0-10L4 7m8 4v10M4 7v10l8 4",
        close: "M6 18L18 6M6 6l12 12",
        user: "M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z",
        alert: "M12 9v4m0 4h.01M10.3 3.9L1.8 18a2 2 0 001.7 3h17a2 2 0 001.7-3L13.7 3.9a2 2 0 00-3.4 0z",
        shield: "M9 12l2 2 4-4m5.6-4a12 12 0 01-8.6-3 12 12 0 01-8.6 3A12 12 0 003 9c0 5.6 3.8 10.3 9 11.6 5.2-1.3 9-6 9-11.6 0-1-.1-2-.4-3z",
        bolt: "M13 10V3L4 14h7v7l9-11h-7z",
        trash: "M19 7l-.9 12a2 2 0 01-2 1.9H7.9a2 2 0 01-2-1.9L5 7m5 4v6m4-6v6M9 7V4a1 1 0 011-1h4a1 1 0 011 1v3M4 7h16",
    };
    return (
        <svg width={size} height={size} fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" viewBox="0 0 24 24" className={className} aria-hidden="true">
            <path d={paths[name]} />
        </svg>
    );
};

// ---------- KOMPONEN KECIL ----------
const SectionHeader = ({ title, desc, right }) => (
    <div className="mb-6 flex flex-col sm:flex-row sm:items-end sm:justify-between gap-3">
        <div>
            <h2 className="text-xl md:text-2xl font-bold tracking-tight text-slate-900">{title}</h2>
            <p className="text-sm text-slate-500 mt-1 max-w-2xl">{desc}</p>
        </div>
        {right}
    </div>
);

const FieldLabel = ({ children, hint }) => (
    <div className="flex items-baseline justify-between mb-1.5">
        <label className="text-xs font-semibold text-slate-700">{children}</label>
        {hint && <span className="text-[11px] text-slate-400">{hint}</span>}
    </div>
);

const CopyGlyph = () => <Icon name="copy" size={14} className="text-slate-500 shrink-0" />;


// ---------- LOGO PANEL VALIDASI GAME (satu warna aksen: #39384D) ----------
const BrandMark = ({ size = 28 }) => (
    <svg width={size} height={size} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg" aria-label="Validasi Game" style={{ display: 'block', flexShrink: 0 }}>
        <defs>
            <linearGradient id="vgBg" x1="4" y1="2" x2="44" y2="46" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#52516B" />
                <stop offset="1" stopColor="#39384D" />
            </linearGradient>
            <linearGradient id="vgShine" x1="24" y1="0" x2="24" y2="26" gradientUnits="userSpaceOnUse">
                <stop offset="0" stopColor="#ffffff" stopOpacity="0.28" />
                <stop offset="1" stopColor="#ffffff" stopOpacity="0" />
            </linearGradient>
        </defs>
        <rect width="48" height="48" rx="13" fill="url(#vgBg)" />
        <rect width="48" height="48" rx="13" fill="url(#vgShine)" />
        <rect x="0.75" y="0.75" width="46.5" height="46.5" rx="12.25" stroke="#ffffff" strokeOpacity="0.22" strokeWidth="1.5" />
        {/* stik game */}
        <g transform="translate(7 8) scale(1.42)" stroke="#ffffff" strokeWidth="1.7" strokeLinecap="round" strokeLinejoin="round">
            <path d="M7 6.5h10a4.2 4.2 0 014.1 4.3l-.5 4.1a2.1 2.1 0 01-3.7 1.1L14.9 14H9.1l-2 2a2.1 2.1 0 01-3.7-1.1l-.5-4.1A4.2 4.2 0 017 6.5z" fill="#ffffff" fillOpacity="0.1" />
            <path d="M8 9.2v3.2M6.4 10.8h3.2" />
            <circle cx="15.6" cy="10.1" r="0.5" fill="#ffffff" />
            <circle cx="17.6" cy="11.9" r="0.5" fill="#ffffff" />
        </g>
        {/* lencana centang validasi */}
        <circle cx="36" cy="36" r="8.5" fill="#34d399" stroke="#39384D" strokeWidth="2.5" />
        <path d="M32.2 36.2l2.6 2.6 5-5.3" stroke="#ffffff" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
);

// ---------- LOGO GAME (Mobile Legends & Free Fire) ----------
// Jika Anda punya file logo resmi, isi URL/path gambarnya di sini
// (contoh: "/logos/mlbb.png"). Bila dikosongkan, dipakai emblem SVG bawaan.
const GAME_LOGO_SRC = {
    ml: "",
    ff: "",
};

const GameLogo = ({ game, size = 48 }) => {
    const src = GAME_LOGO_SRC[game];
    const radius = Math.round(size * 0.26);
    const frame = {
        width: size, height: size, borderRadius: radius, flexShrink: 0, display: 'block',
        boxShadow: '0 4px 14px rgba(15,23,42,0.28), inset 0 0 0 1px rgba(255,255,255,0.12)',
    };
    if (src) {
        return <img src={src} alt={game === 'ml' ? 'Mobile Legends' : 'Free Fire'} width={size} height={size} crossOrigin="anonymous" style={{ ...frame, objectFit: 'cover' }} />;
    }
    if (game === 'ml') {
        return (
            <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={frame} aria-label="Mobile Legends">
                <defs>
                    <linearGradient id="mlBg" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#1e3a8a" />
                        <stop offset="1" stopColor="#0a1030" />
                    </linearGradient>
                    <linearGradient id="mlGold" x1="12" y1="6" x2="36" y2="42" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#fde68a" />
                        <stop offset="0.5" stopColor="#f5b83d" />
                        <stop offset="1" stopColor="#b7791f" />
                    </linearGradient>
                    <radialGradient id="mlGlow" cx="24" cy="22" r="22" gradientUnits="userSpaceOnUse">
                        <stop offset="0" stopColor="#3b82f6" stopOpacity="0.55" />
                        <stop offset="1" stopColor="#3b82f6" stopOpacity="0" />
                    </radialGradient>
                </defs>
                <rect width="48" height="48" rx="12.5" fill="url(#mlBg)" />
                <rect width="48" height="48" rx="12.5" fill="url(#mlGlow)" />
                {/* sayap */}
                <path d="M3.5 17 L11 19 L14 25 L9 26 L12 31 L6 31 Z" fill="url(#mlGold)" opacity="0.9" />
                <path d="M44.5 17 L37 19 L34 25 L39 26 L36 31 L42 31 Z" fill="url(#mlGold)" opacity="0.9" />
                {/* perisai */}
                <path d="M24 5 L36 9.5 V23 C36 31.5 30.8 37.5 24 42 C17.2 37.5 12 31.5 12 23 V9.5 Z" fill="url(#mlGold)" />
                <path d="M24 8.2 L33.2 11.7 V23 C33.2 29.9 29.2 35 24 38.7 C18.8 35 14.8 29.9 14.8 23 V11.7 Z" fill="#0f1b4d" />
                {/* huruf M bergaya bilah */}
                <path d="M17.5 30 V17.5 L24 25 L30.5 17.5 V30" stroke="url(#mlGold)" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round" />
                <path d="M24 12.5 L25.6 16 L24 18.5 L22.4 16 Z" fill="#fde68a" />
            </svg>
        );
    }
    return (
        <svg width={size} height={size} viewBox="0 0 48 48" fill="none" style={frame} aria-label="Free Fire">
            <defs>
                <linearGradient id="ffBg" x1="24" y1="0" x2="24" y2="48" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#ffb21e" />
                    <stop offset="0.55" stopColor="#ff7a00" />
                    <stop offset="1" stopColor="#d9340a" />
                </linearGradient>
                <linearGradient id="ffFlame" x1="24" y1="6" x2="24" y2="38" gradientUnits="userSpaceOnUse">
                    <stop offset="0" stopColor="#fffbe6" />
                    <stop offset="0.6" stopColor="#ffe066" />
                    <stop offset="1" stopColor="#ffb21e" />
                </linearGradient>
            </defs>
            <rect width="48" height="48" rx="12.5" fill="url(#ffBg)" />
            <ellipse cx="24" cy="46" rx="22" ry="12" fill="#7a1500" opacity="0.28" />
            {/* api */}
            <path d="M25 4.5 C26.5 11 34.5 14.5 34.5 24.5 C34.5 31.8 30 37 24 37 C18 37 13.5 31.8 13.5 24.5 C13.5 20.2 15.8 17.2 18.3 15 C18.4 18.2 19.9 19.6 21.6 20 C20.4 14.8 21.6 8.8 25 4.5 Z" fill="url(#ffFlame)" />
            <path d="M24.3 18.5 C25 22 29 23.6 29 28.6 C29 32 26.8 34.2 24 34.2 C21.2 34.2 19 32 19 28.6 C19 26.4 20.2 24.8 21.6 23.6 C21.8 25.3 22.7 26 23.6 26.2 C23.2 23.5 23.4 20.8 24.3 18.5 Z" fill="#e8420c" />
            {/* teks FF */}
            <text x="24" y="44.3" textAnchor="middle" fontFamily="Impact, 'Arial Black', sans-serif" fontSize="9" fontWeight="900" fill="#ffffff" letterSpacing="1.2" style={{ paintOrder: 'stroke' }} stroke="#a82a00" strokeWidth="1.4">FREE FIRE</text>
        </svg>
    );
};

// ---------- IKON STRUK (lencana di header Ringkasan Pesanan, senada dengan kotak produk) ----------
const ReceiptBadge = ({ size = 36 }) => (
    <div
        className="rounded-xl bg-slate-700/60 text-emerald-400 flex items-center justify-center shrink-0 border border-slate-700 relative overflow-hidden"
        style={{ width: size, height: size, boxShadow: 'inset 0 0 14px rgba(52,211,153,0.12)' }}
    >
        <svg width={size * 0.58} height={size * 0.58} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.9" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
            {/* badan struk dengan tepi bergerigi */}
            <path d="M5 3.5h14v17l-2.33-1.5L14.33 20.5 12 19l-2.33 1.5L7.33 19 5 20.5z" />
            {/* centang */}
            <path d="M9 10.2l2.2 2.2L15.2 8.4" />
            {/* garis detail */}
            <path d="M8.5 15.2h7" opacity="0.6" />
        </svg>
    </div>
);

// ---------- KARTU STRUK (dipakai MLBB & Free Fire) ----------
const ReceiptCard = ({ innerRef, data, gameLabel }) => (
    <div
        ref={innerRef}
        className="w-full max-w-sm mx-auto bg-slate-900 rounded-3xl p-6 font-sans relative overflow-hidden shadow-2xl text-slate-100 border border-slate-800"
    >
        {/* Header */}
        <div className="flex items-center justify-between mb-5">
            <div className="flex items-center gap-2">
                <ReceiptBadge size={36} />
                <span className="text-[11px] font-semibold text-slate-400 tracking-wide">Ringkasan Pesanan</span>
            </div>
            <span className="bg-emerald-500/10 text-emerald-400 text-[11px] font-bold px-3 py-1 rounded-full border border-emerald-500/20">
                {data.status || "Sukses"}
            </span>
        </div>

        {/* Ref ID */}
        <div className="mb-5">
            <div className="text-[11px] text-slate-500 mb-1">ID Transaksi</div>
            <div className="text-base font-extrabold text-white tracking-wide break-all flex items-center justify-between gap-2">
                <span>{data.trxId}</span>
                <CopyGlyph />
            </div>
        </div>

        {/* Produk */}
        <div className="bg-slate-800/60 border border-slate-700/60 rounded-2xl p-4 mb-5 flex items-center gap-3">
            <div className="w-10 h-10 rounded-xl bg-slate-700/60 text-emerald-400 flex items-center justify-center shrink-0 border border-slate-700">
                <Icon name="box" size={20} />
            </div>
            <div className="min-w-0">
                <div className="text-[11px] text-slate-400">{gameLabel}</div>
                <div className="text-sm font-bold text-white truncate">{data.product}</div>
            </div>
        </div>

        {/* Garis sobekan struk */}
        <div className="border-t border-dashed border-slate-700 mb-4"></div>

        {/* Detail */}
        <div className="space-y-3 text-xs">
            <div className="flex justify-between items-center gap-4">
                <span className="text-slate-400">Tanggal</span>
                <span className="font-semibold text-slate-200 text-right">{data.time || "-"}</span>
            </div>
            {data.nick && data.nick !== "-" && (
                <div className="flex justify-between items-center gap-4">
                    <span className="text-slate-400">Nickname</span>
                    <span className="font-semibold text-slate-200 text-right break-all">{data.nick}</span>
                </div>
            )}
            <div className="flex justify-between items-center gap-4">
                <span className="text-slate-400">Target</span>
                <span className="font-semibold text-slate-200 text-right break-all">{data.uid}</span>
            </div>
            <div className="flex justify-between items-center gap-4">
                <span className="text-slate-400">Status Bayar</span>
                <span className="bg-emerald-500/10 text-emerald-400 text-[11px] font-bold px-2.5 py-0.5 rounded-full border border-emerald-500/20">Sudah Dibayar</span>
            </div>
        </div>

        {/* Serial / Token */}
        {data.sn && data.sn !== "-" && (
            <div className="mt-5 pt-4 border-t border-dashed border-slate-700">
                <div className="text-[11px] font-semibold text-emerald-400 mb-2">Serial / Token</div>
                <div className="bg-slate-800/50 border border-slate-700/60 rounded-xl p-3 flex justify-between items-center">
                    <span className="font-mono text-xs font-semibold text-slate-200 break-all">{data.sn}</span>
                    <span className="ml-2"><CopyGlyph /></span>
                </div>
            </div>
        )}
    </div>
);

// ---------- KOTAK HASIL CHECKER ----------
const CheckerResult = ({ nickname, error }) => (
    <>
        {nickname && (
            <div className="p-4 bg-emerald-50 border border-emerald-200 rounded-xl animate-fadeIn flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-emerald-500 text-white flex items-center justify-center shrink-0">
                    <Icon name="check" size={16} />
                </div>
                <div className="min-w-0">
                    <div className="text-[11px] font-semibold text-emerald-700">Nickname ditemukan</div>
                    <div className="text-base font-extrabold text-slate-900 break-all">{nickname}</div>
                </div>
            </div>
        )}
        {error && (
            <div className="p-4 bg-red-50 border border-red-200 rounded-xl animate-fadeIn flex items-start gap-3">
                <div className="w-8 h-8 rounded-full bg-red-500 text-white flex items-center justify-center shrink-0">
                    <Icon name="alert" size={16} />
                </div>
                <div className="min-w-0">
                    <div className="text-[11px] font-semibold text-red-700">Gagal memeriksa</div>
                    <div className="text-sm font-medium text-red-600 break-words">{error}</div>
                </div>
            </div>
        )}
    </>
);

const GamesPanel = () => {
    const ffResultRef = useRef(null);
    const mlResultRef = useRef(null);

    // --- STATE GAMES PANEL ---
    const [profitML, setProfitML] = useState(0);
    const [rateTotal, setRateTotal] = useState(90175);
    const [rateDivider, setRateDivider] = useState(330);

    // TAB UTAMA: 'validator' (default) | 'checker' | 'ff' / 'ml' (Table Price)
    const [activeTab, setActiveTab] = useState('validator');

    const [isCopied, setIsCopied] = useState(false);
    const [imageStatus, setImageStatus] = useState('idle');
    const [imageStatusML, setImageStatusML] = useState('idle');

    const [mlInput, setMlInput] = useState("");
    const [ffInput, setFfInput] = useState("");
    const [mlResult, setMlResult] = useState(null);
    const [ffResult, setFfResult] = useState(null);

    // --- STATE API CHECKER FREE FIRE ---
    const [ffCheckId, setFfCheckId] = useState("");
    const [isCheckingFF, setIsCheckingFF] = useState(false);
    const [ffCheckError, setFfCheckError] = useState("");
    const [ffCheckedNickname, setFfCheckedNickname] = useState("");

    // --- STATE API CHECKER MOBILE LEGENDS ---
    const [mlCheckId, setMlCheckId] = useState("");
    const [mlCheckZone, setMlCheckZone] = useState("");
    const [isCheckingML, setIsCheckingML] = useState(false);
    const [mlCheckError, setMlCheckError] = useState("");
    const [mlCheckedNickname, setMlCheckedNickname] = useState("");

    // --- FITUR EDIT CAPTION & SETTINGS ---
    const [customCaption, setCustomCaption] = useState("IFY ONE - Top Up Terpercaya");
    const [showSettings, setShowSettings] = useState(false);

    // --- DATA PRODUK FFP & DENOMINASI ---
    const ffpData = [
        { id: "FFP5", dm: "5 Diamond", sum: 3 },
        { id: "FFP10", dm: "10 Diamond", sum: 6 },
        { id: "FFP12", dm: "12 Diamond", sum: 6.73 },
        { id: "FFP20", dm: "20 Diamond", sum: 12 },
        { id: "FFP25", dm: "25 Diamond", sum: 15 },
        { id: "FFP30", dm: "30 Diamond", sum: 18 },
        { id: "FFP40", dm: "40 Diamond", sum: 23.96 },
        { id: "FFP50", dm: "50 Diamond", sum: 24 },
        { id: "FFP70", dm: "70 Diamond", sum: 33 },
        { id: "FFP75", dm: "75 Diamond", sum: 36 },
        { id: "FFP80", dm: "80 Diamond", sum: 39 },
        { id: "FFP90", dm: "90 Diamond", sum: 45 },
        { id: "FFP95", dm: "95 Diamond", sum: 48 },
        { id: "FFP100", dm: "100 Diamond", sum: 48 },
        { id: "FFP120", dm: "120 Diamond", sum: 57 },
        { id: "FFP130", dm: "130 Diamond", sum: 63 },
        { id: "FFP144", dm: "140 Diamond", sum: 66 },
        { id: "FFP145", dm: "145 Diamond", sum: 69 },
        { id: "FFP150", dm: "150 Diamond", sum: 72 },
        { id: "FFP160", dm: "160 Diamond", sum: 78 },
        { id: "FFP190", dm: "190 Diamond", sum: 90.05 },
        { id: "FFP200", dm: "200 Diamond", sum: 96 },
        { id: "FFP210", dm: "210 Diamond", sum: 99 },
        { id: "FFP250", dm: "250 Diamond", sum: 120 },
        { id: "FFP280", dm: "280 Diamond", sum: 132 },
        { id: "FFP350", dm: "350 Diamond", sum: 164.96 },
        { id: "FFP355", dm: "355 Diamond", sum: 165 },
        { id: "FFP375", dm: "375 Diamond", sum: 177 },
        { id: "FFP400", dm: "400 Diamond", sum: 189 },
        { id: "FFP405", dm: "405 Diamond", sum: 189.03 },
        { id: "FFP425", dm: "425 Diamond", sum: 198.06 },
        { id: "FFP475", dm: "475 Diamond", sum: 222.01 },
        { id: "FFP500", dm: "500 Diamond", sum: 234.05 },
        { id: "FFP510", dm: "510 Diamond", sum: 240 },
        { id: "FFP545", dm: "545 Diamond", sum: 255 },
        { id: "FFP565", dm: "565 Diamond", sum: 264 },
        { id: "FFP600", dm: "600 Diamond", sum: 282 },
        { id: "FFP635", dm: "635 Diamond", sum: 297 },
        { id: "FFP700", dm: "700 Diamond", sum: 330 },
        { id: "FFP720", dm: "720 Diamond", sum: 330 },
        { id: "FFP770", dm: "770 Diamond", sum: 354.2 },
        { id: "FFP790", dm: "790 Diamond", sum: 363 },
        { id: "FFP800", dm: "800 Diamond", sum: 369 },
        { id: "FFP860", dm: "860 Diamond", sum: 396.1 },
        { id: "FFP930", dm: "930 Diamond", sum: 429 },
        { id: "FFP1000", dm: "1000 Diamond", sum: 462 },
        { id: "FFP1050", dm: "1050 Diamond", sum: 486 },
        { id: "FFP1075", dm: "1075 Diamond", sum: 495 },
        { id: "FFP1080", dm: "1080 Diamond", sum: 498 },
        { id: "FFP1200", dm: "1200 Diamond", sum: 555 },
        { id: "FFP1300", dm: "1300 Diamond", sum: 603 },
        { id: "FFP1440", dm: "1440 Diamond", sum: 660 },
        { id: "FFP1450", dm: "1450 Diamond", sum: 666 },
        { id: "FFP2000", dm: "2000 Diamond", sum: 924 },
        { id: "FFP2140", dm: "2140 Diamond", sum: 990 },
        { id: "FFP2180", dm: "2180 Diamond", sum: 996 },
        { id: "FFP2355", dm: "2355 Diamond", sum: 1080 },
        { id: "FFP2720", dm: "2720 Diamond", sum: 1251 },
        { id: "FFP3640", dm: "3640 Diamond", sum: 1659 },
        { id: "FFP4000", dm: "4000 Diamond", sum: 1827 },
        { id: "FFP6000", dm: "6000 Diamond", sum: 2742 },
        { id: "FFP7290", dm: "7290 Diamond", sum: 3300 }
    ];

    const mlData = [
        { id: "MLBWeekly", name: "Weekly Diamond Pass", base: 23295 },
        { id: "MLB5", name: "5 Diamond", base: 1476 },
        { id: "MLB10", name: "10 Diamond", base: 2945 },
        { id: "MLB14", name: "14 Diamond", base: 3929 },
        { id: "MLB22", name: "22 Diamond", base: 6211 },
        { id: "MLB28", name: "28 Diamond", base: 7630 },
        { id: "MLB42", name: "42 Diamond", base: 11422 },
        { id: "MLB56", name: "56 Diamond", base: 14736 },
        { id: "MLB70", name: "70 Diamond", base: 18523 },
        { id: "MLB75", name: "75 Diamond", base: 19944 },
        { id: "MLB78", name: "78 Diamond", base: 20417 },
        { id: "MLB84", name: "84 Diamond", base: 21837 },
        { id: "MLB110", name: "110 Diamond", base: 28205 },
        { id: "MLB210", name: "210 Diamond", base: 53783 },
        { id: "MLB355", name: "355 Diamond", base: 90970 },
        { id: "MLB706", name: "706 Diamond", base: 177359 },
        { id: "MLB1050", name: "1050 Diamond", base: 255472 },
        { id: "MLB2195", name: "2195 Diamond", base: 515140 },
        { id: "MLB3688", name: "3688 Diamond", base: 879895 },
        { id: "MLB532", name: "5532 Diamond", base: 1298059 },
        { id: "MLB9288", name: "9288 Diamond", base: 2168160 }
    ]; 

    const contactInfo = `Website: https://ifyone.site\nDigiflazz: https://digiflazz.com/seller/o6n0Vo\nChannel Telegram: https://t.me/IFYOneofficial\nCustomer Service: @csifyone`;
    const formatNumber = (num) => new Intl.NumberFormat('id-ID').format(num);

    const parseRaw = (text, key) => {
        const pattern = new RegExp(`${key}\\s*[:=]\\s*(.*)`, 'i');
        const match = text.match(pattern);
        return match ? match[1].trim() : "-";
    }; 

    // --- LOGIKA MLBB VALIDATOR ---
    const processMLValidator = () => {
        if (!mlInput.trim()) return;
        let snRaw = parseRaw(mlInput, "SN");
        let sn = snRaw !== "-" ? snRaw.split(/Succsess|Sukses/i)[0].trim() : "-";
        let nick = "-", uid = "-";

        if (sn !== "-" && sn.includes("(") && sn.includes(")")) {
            const match = sn.match(/(.*)\((.*)\)/);
            if (match) { nick = match[1].trim(); uid = match[2].trim(); }
        } else {
            nick = sn;
            uid = parseRaw(mlInput, "Nomor").replace(/^\d+\.\s*/, "");
        }
        
        const product = parseRaw(mlInput, "Produk") !== "-" ? parseRaw(mlInput, "Produk") : parseRaw(mlInput, "Diamond");
        const trxId = (parseRaw(mlInput, "Ref ID") || parseRaw(mlInput, "ID Transaksi") || parseRaw(mlInput, "Nomor")).replace(/^\d+\.\s*/, "").toUpperCase();
        const status = parseRaw(mlInput, "Status") !== "-" ? parseRaw(mlInput, "Status") : "Sukses";

        setMlResult({ trxId, product, nick, uid, time: parseRaw(mlInput, "Tanggal"), sn, status });
    }; 

    // --- LOGIKA FF VALIDATOR ---
    const processFFValidator = () => {
        if (!ffInput.trim()) return;
        
        let product = parseRaw(ffInput, "Produk");
        if (product === "-") product = parseRaw(ffInput, "Diamond");
        
        let finalTrxId = parseRaw(ffInput, "Ref ID");
        if (finalTrxId === "-") finalTrxId = parseRaw(ffInput, "ID Transaksi");
        if (finalTrxId === "-") finalTrxId = parseRaw(ffInput, "Nomor");
        finalTrxId = finalTrxId.replace(/^\d+\.\s*/, "").toUpperCase();

        let sn = parseRaw(ffInput, "SN");
        let nick = "-";
        let uid = parseRaw(ffInput, "Nomor").replace(/^\d+\.\s*/, "");

        if (sn !== "-") {
            if (sn.toUpperCase().includes("REFID")) {
                const parts = sn.split(/RefId\s*[: ]\s*/i);
                nick = parts[0].replace(/[.\s-]+$/, "");
                finalTrxId = parts[1] ? parts[1].trim().toUpperCase() : finalTrxId;
            } else if (sn.includes("(") && sn.includes(")")) {
                const match = sn.match(/(.*)\((.*)\)/);
                if (match) { 
                    nick = match[1].trim(); 
                    uid = match[2].trim(); 
                }
            } else {
                nick = sn;
            }
        }

        const status = parseRaw(ffInput, "Status") !== "-" ? parseRaw(ffInput, "Status") : "Sukses";

        setFfResult({ trxId: finalTrxId, product, nick, uid, time: parseRaw(ffInput, "Tanggal"), sn, status });
    }; 

    // --- LOGIKA REAL-TIME API CHECK ID FREE FIRE ---
    const checkFreeFireId = async () => {
        if (!ffCheckId.trim()) {
            setFfCheckError("Masukkan User ID Free Fire terlebih dahulu Om!");
            return;
        }
        setIsCheckingFF(true);
        setFfCheckError("");
        setFfCheckedNickname("");
        try {
            const response = await fetch(`https://api.omegatronik.co.id/api/game/freefire-dg?key=bIQGfd2WhB&id=${encodeURIComponent(ffCheckId)}`);
            if (!response.ok) {
                setFfCheckError(`Server error status: ${response.status}`);
                setIsCheckingFF(false);
                return;
            }
            const data = await response.json();
            let foundNickname = "";
            if (data) {
                if (data.data && data.data.username) foundNickname = data.data.username; 
                else if (data.nickname) foundNickname = data.nickname;
                else if (data.name) foundNickname = data.name;
                else if (data.username) foundNickname = data.username;
                else if (data.player_name) foundNickname = data.player_name;
                else if (data.data && data.data.nickname) foundNickname = data.data.nickname;
                else if (data.data && data.data.name) foundNickname = data.data.name;
            }
            if (foundNickname && foundNickname !== "-") {
                setFfCheckedNickname(foundNickname);
            } else {
                let apiMessage = data?.message || data?.error || data?.msg || "ID tidak ditemukan atau API Limit, Om.";
                setFfCheckError(apiMessage);
            }
        } catch (error) {
            setFfCheckError("Gagal terhubung ke API Omegatronik (Masalah Jaringan / CORS).");
        } finally {
            setIsCheckingFF(false);
        }
    };

    // --- LOGIKA REAL-TIME API CHECK ID MOBILE LEGENDS ---
    const checkMobileLegendsId = async () => {
        if (!mlCheckId.trim() || !mlCheckZone.trim()) {
            setMlCheckError("Masukkan User ID dan Zone ID Mobile Legends terlebih dahulu Om!");
            return;
        }
        setIsCheckingML(true);
        setMlCheckError("");
        setMlCheckedNickname("");
        try {
            const response = await fetch(`https://api.omegatronik.co.id/api/game/check-region-mlbb?key=bIQGfd2WhB&id=${encodeURIComponent(mlCheckId)}&zone=${encodeURIComponent(mlCheckZone)}`);
            if (!response.ok) {
                setMlCheckError(`Server error status: ${response.status}`);
                setIsCheckingML(false);
                return;
            }
            const data = await response.json();
            let foundNickname = "";
            if (data) {
                if (data.data && data.data.username) foundNickname = data.data.username; 
                else if (data.nickname) foundNickname = data.nickname;
                else if (data.name) foundNickname = data.name;
                else if (data.username) foundNickname = data.username;
                else if (data.player_name) foundNickname = data.player_name;
                else if (data.data && data.data.nickname) foundNickname = data.data.nickname;
                else if (data.data && data.data.name) foundNickname = data.data.name;
            }
            if (foundNickname && foundNickname !== "-") {
                setMlCheckedNickname(foundNickname);
            } else {
                let apiMessage = data?.message || data?.error || data?.msg || "ID / Zone tidak ditemukan atau API Limit, Om.";
                setMlCheckError(apiMessage);
            }
        } catch (error) {
            setMlCheckError("Gagal terhubung ke API Omegatronik (Masalah Jaringan / CORS).");
        } finally {
            setIsCheckingML(false);
        }
    };

    const generateFFP = () => {
        const currentRate = rateTotal / (rateDivider || 1);
        let text = `TOP UP FREE FIRE\n\n`;
        ffpData.forEach(item => {
            let hpp = Math.ceil(item.sum * currentRate);
            text += `${item.id.padEnd(9, ' ')}${item.dm.padEnd(15, ' ')}${formatNumber(hpp)}\n`;
        });
        text += `\nKeunggulan Produk:\n • 100% Valid\n • Jalur KiosGamer\n • Speed Detikan\n • Tersedia Screenshot web\n\n${contactInfo}`;
        return text;
    }; 

    const generateMLB = () => {
        const margin = parseFloat(profitML) || 0;
        let text = `Daftar Harga Mobile Legends (MLB)\n${customCaption}\n\n`;
        mlData.forEach(item => {
            let harga = Math.round(item.base * (1 + (margin / 100)));
            text += `${item.id.padEnd(10, ' ')} ${item.name.padEnd(22, ' ')} ${formatNumber(harga)}\n`;
        });
        text += `\nKeunggulan Produk:\n • 100% Valid\n • Jalur Direct Vendor\n\n${contactInfo}`;
        return text;
    }; 

    const handleCopy = () => {
        const content = activeTab === 'ml' ? generateMLB() : generateFFP();
        navigator.clipboard.writeText(content);
        setIsCopied(true);
        setTimeout(() => setIsCopied(false), 2000);
    }; 

    const captureComponent = async (ref, setStatus, fileName) => {
        if (!ref.current) return;
        setStatus('loading');
        await new Promise(resolve => setTimeout(resolve, 200));
        try {
            const canvas = await html2canvas(ref.current, {
                backgroundColor: "#0f172a", 
                scale: 3, 
                useCORS: true,
                allowTaint: true,
                logging: false,
            });
            canvas.toBlob(async (blob) => {
                if (!blob) { setStatus('idle'); return; }
                try {
                    const item = new ClipboardItem({ "image/png": blob });
                    await navigator.clipboard.write([item]);
                    setStatus('success');
                } catch (err) {
                    const url = URL.createObjectURL(blob);
                    const link = document.createElement('a');
                    link.href = url;
                    link.download = `${fileName}-${Date.now()}.png`;
                    link.click();
                    setStatus('success');
                } finally {
                    setTimeout(() => setStatus('idle'), 2500);
                }
            }, "image/png");
        } catch (err) { setStatus('idle'); }
    };

    // --- NAVIGASI UTAMA ---
    const isPricingTab = activeTab === 'ml' || activeTab === 'ff';
    const navItems = [
        { id: 'validator', label: 'Validator Struk', icon: 'receipt', active: activeTab === 'validator', go: () => setActiveTab('validator') },
        { id: 'checker', label: 'Checker ID', icon: 'search', active: activeTab === 'checker', go: () => setActiveTab('checker') },
        { id: 'pricing', label: 'Table Price', icon: 'table', active: isPricingTab, go: () => setActiveTab(isPricingTab ? activeTab : 'ff') },
    ];

    // --- KELAS TAMPILAN ---
    const cardClass = "bg-white border border-slate-200 rounded-2xl shadow-sm";
    const inputClass = "w-full px-3.5 py-3 rounded-xl border border-slate-300 bg-white text-slate-900 placeholder:text-slate-400 text-sm font-medium outline-none transition focus:border-[#39384D] focus:ring-4 focus:ring-[#39384D]/10";
    const primaryBtn = "inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-[#39384D] hover:bg-[#2c2b3d] text-white text-sm font-semibold shadow-sm transition active:scale-[0.98] disabled:opacity-50 disabled:cursor-not-allowed focus:outline-none focus-visible:ring-4 focus-visible:ring-[#39384D]/30";
    const secondaryBtn = "inline-flex items-center justify-center gap-2 px-5 py-3 rounded-xl bg-white hover:bg-slate-50 border border-slate-300 text-slate-700 text-sm font-semibold transition active:scale-[0.98] focus:outline-none focus-visible:ring-4 focus-visible:ring-[#39384D]/20";

    const captureLabel = (status) => status === 'loading' ? 'Memproses...' : status === 'success' ? 'Gambar tersalin' : 'Salin gambar';

    return (
        <div className="min-h-screen w-full bg-slate-100 text-slate-800 font-sans">

            {/* ================= TOP BAR ================= */}
            <header className="sticky top-0 z-30 bg-white/90 backdrop-blur border-b border-slate-200">
                <div className="max-w-7xl mx-auto px-4 md:px-8 h-16 flex items-center justify-between gap-4">
                    <div className="flex items-center gap-3 shrink-0">
                        <BrandMark size={36} />
                        <div className="leading-tight">
                            <div className="text-sm font-extrabold tracking-tight text-slate-900">Validasi Game</div>
                            <div className="hidden sm:block text-[11px] text-slate-500">Gateway Operations Panel</div>
                        </div>
                    </div>

                    {/* Navigasi desktop */}
                    <nav className="hidden md:flex items-center gap-1 bg-slate-100 p-1 rounded-xl" aria-label="Menu utama">
                        {navItems.map(item => (
                            <button
                                key={item.id}
                                onClick={item.go}
                                aria-current={item.active ? 'page' : undefined}
                                className={`px-4 py-2 rounded-lg text-sm font-semibold flex items-center gap-2 transition ${item.active ? 'bg-white text-[#39384D] shadow-sm' : 'text-slate-600 hover:text-slate-900'}`}
                            >
                                <Icon name={item.icon} size={15} />
                                <span>{item.label}</span>
                            </button>
                        ))}
                    </nav>

                    <button
                        onClick={() => setShowSettings(!showSettings)}
                        className={`p-2.5 rounded-xl border transition ${showSettings ? 'bg-[#39384D]/10 border-[#39384D]/25 text-[#39384D]' : 'bg-white border-slate-200 text-slate-500 hover:text-[#39384D] hover:border-[#39384D]/30'}`}
                        title="Pengaturan caption promosi"
                        aria-label="Pengaturan"
                    >
                        <Icon name="settings" size={18} />
                    </button>
                </div>

                {/* Navigasi mobile */}
                <nav className="md:hidden flex items-center gap-1 px-3 pb-3" aria-label="Menu utama">
                    {navItems.map(item => (
                        <button
                            key={item.id}
                            onClick={item.go}
                            aria-current={item.active ? 'page' : undefined}
                            className={`flex-1 px-2 py-2.5 rounded-lg text-xs font-semibold flex items-center justify-center gap-1.5 transition ${item.active ? 'bg-[#39384D] text-white shadow-sm' : 'bg-slate-100 text-slate-600'}`}
                        >
                            <Icon name={item.icon} size={14} />
                            <span>{item.label}</span>
                        </button>
                    ))}
                </nav>
            </header>

            <main className="max-w-7xl mx-auto px-4 md:px-8 py-6 md:py-10">

                {/* ================= PENGATURAN ================= */}
                {showSettings && (
                    <div className={`mb-8 p-5 md:p-6 ${cardClass} animate-fadeIn`}>
                        <div className="flex items-center justify-between mb-4">
                            <div>
                                <h3 className="text-sm font-bold text-slate-900">Pengaturan Promosi</h3>
                                <p className="text-xs text-slate-500 mt-0.5">Caption ini tampil pada teks daftar harga Mobile Legends.</p>
                            </div>
                            <button onClick={() => setShowSettings(false)} className="p-1.5 rounded-lg text-slate-400 hover:text-slate-700 hover:bg-slate-100" aria-label="Tutup pengaturan">
                                <Icon name="close" size={18} />
                            </button>
                        </div>
                        <div className="grid grid-cols-1 md:grid-cols-[1fr_auto] gap-4 items-end">
                            <div>
                                <FieldLabel>Caption promosi utama</FieldLabel>
                                <input type="text" value={customCaption} onChange={(e) => setCustomCaption(e.target.value)} className={inputClass} placeholder="Contoh: IFY ONE - Top Up Terpercaya" />
                            </div>
                            <button onClick={() => setShowSettings(false)} className={primaryBtn}>Simpan perubahan</button>
                        </div>
                    </div>
                )}

                {/* ================= HALAMAN 1: VALIDATOR STRUK ================= */}
                {activeTab === 'validator' && (
                    <section className="animate-fadeIn">
                        <SectionHeader
                            title="Validator Struk"
                            desc="Tempel data mentah transaksi dari Digiswitch, Pastikan SN pada Respon dipindahkan ke Reffid dan Nickname benar benar sesuai."
                        />

                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 items-start">

                            {/* INPUT */}
                            <div className="lg:col-span-5 space-y-6">
                                <div className={`p-5 md:p-6 ${cardClass}`}>
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-10 h-10 rounded-xl bg-[#39384D]/10 text-[#39384D] border border-[#39384D]/15 flex items-center justify-center text-xs font-extrabold">ML</div>
                                        <div>
                                            <h3 className="text-sm font-bold text-slate-900">Struk Mobile Legends</h3>
                                            <p className="text-xs text-slate-500">Data transaksi MLBB</p>
                                        </div>
                                    </div>
                                    <textarea
                                        rows="5"
                                        value={mlInput}
                                        onChange={(e) => setMlInput(e.target.value)}
                                        placeholder="Tempel data transaksi MLBB di sini..."
                                        className={`${inputClass} resize-none font-mono text-xs leading-relaxed`}
                                    />
                                    <div className="flex gap-2 mt-3">
                                        <button onClick={processMLValidator} className={`${primaryBtn} flex-1`}>Proses data MLBB</button>
                                        <button
                                            onClick={() => { setMlInput(""); setMlResult(null); }}
                                            className={`${secondaryBtn} px-4`}
                                            title="Bersihkan"
                                            aria-label="Bersihkan data MLBB"
                                        >
                                            <Icon name="trash" size={16} />
                                        </button>
                                    </div>
                                </div>

                                <div className={`p-5 md:p-6 ${cardClass}`}>
                                    <div className="flex items-center gap-3 mb-4">
                                        <div className="w-10 h-10 rounded-xl bg-[#39384D]/10 text-[#39384D] border border-[#39384D]/15 flex items-center justify-center text-xs font-extrabold">FF</div>
                                        <div>
                                            <h3 className="text-sm font-bold text-slate-900">Struk Free Fire</h3>
                                            <p className="text-xs text-slate-500">Data transaksi Garena Free Fire</p>
                                        </div>
                                    </div>
                                    <textarea
                                        rows="5"
                                        value={ffInput}
                                        onChange={(e) => setFfInput(e.target.value)}
                                        placeholder="Tempel data transaksi Free Fire di sini..."
                                        className={`${inputClass} resize-none font-mono text-xs leading-relaxed`}
                                    />
                                    <div className="flex gap-2 mt-3">
                                        <button onClick={processFFValidator} className={`${primaryBtn} flex-1`}>Proses data Free Fire</button>
                                        <button
                                            onClick={() => { setFfInput(""); setFfResult(null); }}
                                            className={`${secondaryBtn} px-4`}
                                            title="Bersihkan"
                                            aria-label="Bersihkan data Free Fire"
                                        >
                                            <Icon name="trash" size={16} />
                                        </button>
                                    </div>
                                </div>
                            </div>

                            {/* PREVIEW */}
                            <div className="lg:col-span-7 space-y-8">
                                {!mlResult && !ffResult && (
                                    <div className="rounded-2xl border-2 border-dashed border-slate-300 bg-white/60 py-20 px-6 text-center">
                                        <div className="w-14 h-14 mx-auto rounded-2xl bg-slate-100 text-slate-400 flex items-center justify-center mb-4">
                                            <Icon name="receipt" size={26} />
                                        </div>
                                        <h3 className="text-sm font-bold text-slate-700">Belum ada struk</h3>
                                        <p className="text-xs text-slate-500 mt-1 max-w-xs mx-auto">Tempel data transaksi di panel kiri lalu tekan proses. Pratinjau struk akan muncul di sini.</p>
                                    </div>
                                )}

                                {mlResult && (
                                    <div className="space-y-3 animate-fadeIn">
                                        <div className="flex items-center justify-between gap-3">
                                            <h3 className="text-sm font-bold text-slate-900">Pratinjau struk Mobile Legends</h3>
                                            <button
                                                onClick={() => captureComponent(mlResultRef, setImageStatusML, "MLBB-Struk")}
                                                className={`${primaryBtn} !py-2 !px-4 !text-xs`}
                                            >
                                                <Icon name={imageStatusML === 'success' ? 'check' : 'image'} size={14} />
                                                {captureLabel(imageStatusML)}
                                            </button>
                                        </div>
                                        <ReceiptCard innerRef={mlResultRef} data={mlResult} gameLabel="Mobile Legends: Bang Bang" />
                                    </div>
                                )}

                                {ffResult && (
                                    <div className="space-y-3 animate-fadeIn">
                                        <div className="flex items-center justify-between gap-3">
                                            <h3 className="text-sm font-bold text-slate-900">Pratinjau struk Free Fire</h3>
                                            <button
                                                onClick={() => captureComponent(ffResultRef, setImageStatus, "FF-Struk")}
                                                className={`${primaryBtn} !py-2 !px-4 !text-xs`}
                                            >
                                                <Icon name={imageStatus === 'success' ? 'check' : 'image'} size={14} />
                                                {captureLabel(imageStatus)}
                                            </button>
                                        </div>
                                        <ReceiptCard innerRef={ffResultRef} data={ffResult} gameLabel="Garena Free Fire" />
                                    </div>
                                )}
                            </div>
                        </div>
                    </section>
                )}

                {/* ================= HALAMAN 2: CHECKER ID ================= */}
                {activeTab === 'checker' && (
                    <section className="animate-fadeIn">
                        <SectionHeader
                            title="Checker ID"
                            desc="Verifikasi nickname pemain secara real-time sebelum transaksi diproses, untuk mencegah salah target top up."
                        />

                        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-8 items-start">

                            {/* FREE FIRE */}
                            <div className={`p-5 md:p-7 ${cardClass}`}>
                                <div className="flex items-center gap-4 mb-6">
                                    <GameLogo game="ff" size={48} />
                                    <div>
                                        <h3 className="text-base font-bold text-slate-900">Free Fire</h3>
                                        <p className="text-xs text-slate-500">Cek nickname lewat Player ID</p>
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div>
                                        <FieldLabel>Player ID</FieldLabel>
                                        <input
                                            type="text"
                                            inputMode="numeric"
                                            placeholder="Contoh: 12345678"
                                            value={ffCheckId}
                                            onChange={(e) => setFfCheckId(e.target.value)}
                                            onKeyDown={(e) => { if (e.key === 'Enter') checkFreeFireId(); }}
                                            className={inputClass}
                                        />
                                    </div>
                                    <button onClick={checkFreeFireId} disabled={isCheckingFF} className={`${primaryBtn} w-full`}>
                                        {isCheckingFF
                                            ? <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div><span>Memeriksa...</span></>
                                            : <><Icon name="search" size={16} /><span>Periksa nickname</span></>}
                                    </button>
                                    <CheckerResult nickname={ffCheckedNickname} error={ffCheckError} />
                                </div>
                            </div>

                            {/* MOBILE LEGENDS */}
                            <div className={`p-5 md:p-7 ${cardClass}`}>
                                <div className="flex items-center gap-4 mb-6">
                                    <GameLogo game="ml" size={48} />
                                    <div>
                                        <h3 className="text-base font-bold text-slate-900">Mobile Legends</h3>
                                        <p className="text-xs text-slate-500">Cek nickname lewat User ID dan Zone ID</p>
                                    </div>
                                </div>

                                <div className="space-y-4">
                                    <div className="grid grid-cols-3 gap-3">
                                        <div className="col-span-2">
                                            <FieldLabel>User ID</FieldLabel>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                placeholder="Contoh: 8639264"
                                                value={mlCheckId}
                                                onChange={(e) => setMlCheckId(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') checkMobileLegendsId(); }}
                                                className={inputClass}
                                            />
                                        </div>
                                        <div>
                                            <FieldLabel>Zone ID</FieldLabel>
                                            <input
                                                type="text"
                                                inputMode="numeric"
                                                placeholder="23423"
                                                value={mlCheckZone}
                                                onChange={(e) => setMlCheckZone(e.target.value)}
                                                onKeyDown={(e) => { if (e.key === 'Enter') checkMobileLegendsId(); }}
                                                className={`${inputClass} text-center`}
                                            />
                                        </div>
                                    </div>
                                    <button onClick={checkMobileLegendsId} disabled={isCheckingML} className={`${primaryBtn} w-full`}>
                                        {isCheckingML
                                            ? <><div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div><span>Memeriksa...</span></>
                                            : <><Icon name="search" size={16} /><span>Periksa nickname</span></>}
                                    </button>
                                    <CheckerResult nickname={mlCheckedNickname} error={mlCheckError} />
                                </div>
                            </div>
                        </div>
                    </section>
                )}

                {/* ================= HALAMAN 3: TABLE PRICE ================= */}
                {isPricingTab && (
                    <section className="animate-fadeIn">
                        <SectionHeader
                            title="Table Price"
                            desc="Hitung dan salin daftar harga jual. Free Fire memakai HPP per unit diamond, Mobile Legends memakai persentase margin."
                        />

                        <div className="grid grid-cols-1 lg:grid-cols-12 gap-6 md:gap-8 items-start">

                            {/* KONTROL */}
                            <div className={`lg:col-span-5 p-5 md:p-6 space-y-6 ${cardClass}`}>
                                <div className="flex p-1 bg-slate-100 rounded-xl">
                                    <button
                                        onClick={() => setActiveTab('ff')}
                                        className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition ${activeTab === 'ff' ? 'bg-white text-[#39384D] shadow-sm' : 'text-slate-600 hover:text-slate-900'}`}
                                    >
                                        Free Fire
                                    </button>
                                    <button
                                        onClick={() => setActiveTab('ml')}
                                        className={`flex-1 py-2.5 text-sm font-semibold rounded-lg transition ${activeTab === 'ml' ? 'bg-white text-[#39384D] shadow-sm' : 'text-slate-600 hover:text-slate-900'}`}
                                    >
                                        Mobile Legends
                                    </button>
                                </div>

                                <div className="space-y-4">
                                    {activeTab === 'ff' ? (
                                        <>
                                            <div>
                                                <FieldLabel hint="Rupiah">Total pembelian modal</FieldLabel>
                                                <input type="number" value={rateTotal} onChange={(e) => setRateTotal(Number(e.target.value))} className={inputClass} />
                                            </div>
                                            <div>
                                                <FieldLabel hint="DM per unit">Pembagi KiosGamer</FieldLabel>
                                                <input type="number" value={rateDivider} onChange={(e) => setRateDivider(Number(e.target.value))} className={inputClass} />
                                            </div>
                                            <div className="p-4 rounded-xl bg-[#39384D]/10 border border-[#39384D]/15 flex justify-between items-center">
                                                <span className="text-xs font-semibold text-slate-600">HPP per 1 unit DM</span>
                                                <span className="text-base font-extrabold text-[#39384D]">Rp {formatNumber(Math.ceil(rateTotal / (rateDivider || 1)))}</span>
                                            </div>
                                        </>
                                    ) : (
                                        <div>
                                            <FieldLabel hint="Persen">Markup keuntungan bersih</FieldLabel>
                                            <input type="number" step="0.1" value={profitML} onChange={(e) => setProfitML(e.target.value)} className={inputClass} placeholder="Contoh: 3.5" />
                                            <p className="text-[11px] text-slate-400 mt-2">Harga jual = harga dasar + markup. Caption promosi bisa diubah dari ikon pengaturan di pojok kanan atas.</p>
                                        </div>
                                    )}
                                </div>

                                <button onClick={handleCopy} className={`${primaryBtn} w-full`}>
                                    <Icon name={isCopied ? 'check' : 'copy'} size={16} />
                                    <span>{isCopied ? "Berhasil disalin" : "Salin teks harga"}</span>
                                </button>
                            </div>

                            {/* OUTPUT */}
                            <div className="lg:col-span-7">
                                <div className="rounded-2xl border border-slate-200 overflow-hidden shadow-sm flex flex-col bg-white">
                                    <div className="px-5 py-3.5 border-b border-slate-200 flex items-center justify-between bg-slate-50">
                                        <div className="flex items-center gap-2">
                                            <span className="w-2.5 h-2.5 rounded-full bg-emerald-500"></span>
                                            <span className="text-xs font-semibold text-slate-600">Pratinjau daftar harga</span>
                                        </div>
                                        <span className="text-xs font-bold text-[#39384D] bg-[#39384D]/10 border border-[#39384D]/15 px-2.5 py-1 rounded-md">
                                            {activeTab === 'ml' ? 'Mobile Legends' : 'Free Fire'}
                                        </span>
                                    </div>

                                    <div className="p-5 md:p-6 overflow-auto max-h-[70vh] font-mono text-xs leading-relaxed text-slate-700 select-all whitespace-pre">
                                        {activeTab === 'ml' ? generateMLB() : generateFFP()}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </section>
                )}
            </main>

            <footer className="max-w-7xl mx-auto px-4 md:px-8 pb-8 text-center text-[11px] text-slate-400">
                Validasi Game &middot; Gateway Operations Panel
            </footer>

            <style>{`
                @keyframes fadeIn {
                    from { opacity: 0; transform: translateY(6px); }
                    to { opacity: 1; transform: translateY(0); }
                }
                .animate-fadeIn { animation: fadeIn 0.25s ease-out forwards; }
                @media (prefers-reduced-motion: reduce) {
                    .animate-fadeIn { animation: none; }
                }
            `}</style>
        </div>
    );
};

export default GamesPanel;